import { createSelector } from 'reselect';
import {
    filter, find, get, has, values,
} from 'lodash';

/**
 * Base Selectors
 */
const getEntityId = (state, id) => id;
const getEntities = (state) => get(state, 'app.database.memberAssistants', {});
const getAuth = (state) => get(state, 'app.auth', {});
const getMetaEntities = (state) => get(state, 'app.metaDatabase.memberAssistants', {});
const getMembers = (state) => get(state, 'app.database.members', {});
const getMemberEmails = (state) => get(state, 'app.database.memberEmails', {});
const getMemberPhones = (state) => get(state, 'app.database.memberPhones', {});

export const buildAssistantsSelector = () => createSelector([
    getAuth, getEntities, getMembers, getMemberEmails, getMemberPhones,
], (authState, entities, members, memberEmails, memberPhones) => values(entities).map((entity) =>
{
    if (entity.member_id !== authState.user.member.id)
    {
        return null;
    }

    const emails = filter(memberEmails, { member_id: entity.assistant_id });
    const phones = filter(memberPhones, { member_id: entity.assistant_id });
    const member = find(members, { id: entity.assistant_id });

    return {
        ...entity,
        assistant: {
            ...member,
            memberEmails: emails,
            memberPhones: phones,
        },
    };
}).filter((n) => n));

export const buildMemberAssistantsSelector = () => createSelector([
    getEntityId, getEntities, getMembers,
], (memberId, entities, members) => values(entities).map((entity) =>
{
    if (entity.member_id !== memberId)
    {
        return null;
    }

    const member = find(members, { id: entity.assistant_id });
    return {
        ...entity,
        assistant: {
            ...member,
        },
    };
}).filter((n) => n));

export const buildMetaMemberAssistantSelector = () => createSelector([getEntityId, getMetaEntities], (entityId, metaEntities) =>
{
    if (has(metaEntities, entityId))
    {
        return metaEntities[entityId];
    }

    return {};
});
